import { Flex } from "@chakra-ui/react";
import { useIntl } from "react-intl";

import { Asset } from "__graphql__/types";
import { HEIGHT as HEADER_HEIGHT } from "app/components/Header";
import { TitleS } from "ui/Typography/Typography";

import { BatteryCard } from "./cards/BatteryCard";

export function BatteriesList({
  functionalList,
  nonFunctionalList,
}: {
  functionalList: Asset[];
  nonFunctionalList: Asset[];
}) {
  const intl = useIntl();
  return (
    <Flex minH={`calc(100vh - ${HEADER_HEIGHT} - 2rem)`} px="s200" gap="s300" direction="column">
      {functionalList.length > 0 && (
        <Flex gap="s200" direction="column">
          <TitleS ml="s200">
            {intl.formatMessage(
              { id: "pages.inventory.battery-management-page.functional" },
              { count: functionalList.length },
            )}
          </TitleS>
          {functionalList.map((battery) => (
            <BatteryCard
              key={battery.id}
              state={battery.state}
              model={battery.model ?? undefined}
              serialNumber={battery.serialNumber}
              batteryId={battery.id}
            />
          ))}
        </Flex>
      )}

      {nonFunctionalList.length > 0 && (
        <Flex gap="s200" direction="column">
          <TitleS ml="s200">
            {intl.formatMessage(
              { id: "pages.inventory.battery-management-page.non-functional" },
              { count: nonFunctionalList.length },
            )}
          </TitleS>
          {nonFunctionalList.map((battery) => (
            <BatteryCard
              key={battery.id}
              batteryId={battery.id}
              state={battery.state}
              model={battery.model ?? undefined}
              serialNumber={battery.serialNumber}
            />
          ))}
        </Flex>
      )}
    </Flex>
  );
}
